import React, { useEffect, useRef, useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import { User } from '../../../global';
import axiosHelper from '../../../helpers/axiosHelper';
import FormField from '../../Forms/FormField';
import CountrySelect from '../../Forms/DropDown/CountrySelect';
import ErrorBlock from '../../Forms/ErrorBlock';
import JobSelect from '../../Forms/DropDown/JobSelect';
import { containsOnlyNumbers } from '../../../helpers/validators';

interface Props {
  user: User;
  setUser?: (user: User) => void;
}

const ProfileForUpload: React.FC<Props> = ({ user, setUser }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm<Partial<User>>({
    defaultValues: user,
  });

  const onSubmit: SubmitHandler<Partial<User>> = async (data) => {
    const response = await axiosHelper.updateDSLUser(data);
    console.log(response);
    if (response) {
      if (setUser) {
        setUser(response);
      }
    }
  };

  return (
    <div className="bg-light-gray">
      <main className="container">
        <div className="row ">
          {/* Left column  ====================================================== */}
          <div className="col-12 col-md-12 ">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row  ">
                <div className="col-12   ">
                  <div className="row mb-7 ">
                    <div className="col-12 col-md-2 text fw-bold"></div>
                    <div className="col-12 col-md-10">
                      <span className="text color-blue">
                        <i>
                          <b>
                            <span className="form-required">*</span> &nbsp; Mandatory fields (required to upload your design)
                          </b>
                        </i>
                      </span>
                    </div>
                  </div>
                  <FormField name="username" label="Username">
                    <input type="text" style={{ border: '0px ' }} id="username" disabled={true} {...register('username')} />
                  </FormField>

                  <FormField name="firstName" label="First name" required error={errors.firstName}>
                    <input type="text" {...register('firstName', { required: 'First name is required' })} />
                  </FormField>
                  <FormField name="lastName" label="Last name" required error={errors.lastName}>
                    <input type="text" {...register('lastName', { required: 'Last name is required' })} />
                  </FormField>

                  <FormField
                    name="mobileNumber"
                    label="Mobile Number"
                    required
                    clarification="The phone number will be kept confidential and will be used in case of winning for any urgent communications"
                    error={errors.mobileNumber}
                  >
                    <input type="text" {...register('mobileNumber', { required: 'Mobile Number is required', validate: containsOnlyNumbers })} />
                  </FormField>

                  <FormField name="addressLine1" label="Address" required error={errors.addressLine1}>
                    <input type="text" {...register('addressLine1', { required: 'Address is required' })} />
                  </FormField>

                  <FormField name="city" label="City" required error={errors.city}>
                    <input type="text" {...register('city', { required: 'City is required' })} />
                  </FormField>

                  <FormField name="state" label="State/ Province/ Region" required error={errors.state}>
                    <input type="text" {...register('state', { required: 'State/ Province/ Region is required' })} />
                  </FormField>

                  <FormField name="zipCode" label="Zip Code" required error={errors.zipCode}>
                    <input type="text" {...register('zipCode', { required: 'Zip Code is required' })} />
                  </FormField>

                  <FormField name="job" label="Who are you" required noErrorBlock>
                    <Controller
                      name="job"
                      control={control}
                      rules={{ required: 'Job is required' }}
                      render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <>
                          <JobSelect value={value} onChange={onChange} />
                          <ErrorBlock error={error} />
                        </>
                      )}
                    />
                  </FormField>

                  <FormField name="country" label="Your current country" required noErrorBlock>
                    <Controller
                      name="country"
                      control={control}
                      rules={{ required: 'Country is required' }}
                      render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <>
                          <CountrySelect value={value} onChange={onChange} />
                          <ErrorBlock error={error} />
                        </>
                      )}
                    />
                  </FormField>

                  <FormField name="school1" label="School/ University" required error={errors.school1}>
                    <input
                      type="text"
                      {...register('school1', {
                        required: 'School/ University is required',
                      })}
                    />
                  </FormField>

                  <FormField name="freelanceLicense" label="License to work as freelancer" required error={errors.freelanceLicense}>
                    <div className="col-12 d-flex flex-row justify-content-between align-items-center ">
                      <div>
                        <input type="radio" value="Y" {...register('freelanceLicense', { required: 'We need to know if you have a license to work as freelancer' })} />
                        <label>Yes</label>
                      </div>
                      <div>
                        <input type="radio" value="F" {...register('freelanceLicense', { required: 'We need to know if you have a license to work as freelancer' })} />
                        <label>No</label>
                      </div>
                      <div></div>
                      <div></div>
                    </div>
                  </FormField>

                  <div className="row  d-flex justify-content-center align-items-center mb-7 mt-7">
                    <button className="btn-success rounded col-md-2 mx-5">update</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProfileForUpload;
